export const SET_MUN_TYPE = 'SET_MUNICIP_TYPE';

export const setMunType = props => {
  return {
    type: SET_MUN_TYPE,
    data: props
  }
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/munRegion/actions.js